import type { GroupBase } from '@/components/UI/Form/types'

export const DIALOGUES_LANDING_PAGE_REF = 'DIALOGUES_LANDING_PAGE'
export const UCHICAGO_DIALOGUES_REF = 'UCHICAGO-DIALOGUES'

export const DIALOGUES_REFERRAL_CODES = [DIALOGUES_LANDING_PAGE_REF, UCHICAGO_DIALOGUES_REF]

export const DIALOGUES_PROGRAM_MANAGER_FIRST_NAME = 'Kelly'

export const DIALOGUE_EVENT_MAX_AGE = 19
export const DIALOGUE_CLUB_MAX_AGE = 22

export const QUERY_REFLECTION_SESSION_ID = 'reflectionSessionId'

export const DIALOGUES_REFLECTION_EXPIRES_AFTER_DAYS = 14

export const DIALOGUE_EVENT_OFFERING_SLUG = 'dialogues-event'
export const DIALOGUE_CLUB_OFFERING_SLUG = 'dialogues-club'

export const DIALOGUES_ITERATION_SLUGS = ['always-open'] as const
export type DialoguesIterationSlug = (typeof DIALOGUES_ITERATION_SLUGS)[number]

export interface DiscussionTopicGroup {
  group: string
  items: string[]
}

export const DISCUSSION_TOPICS: DiscussionTopicGroup[] = [
  {
    group: '🐘 Political',
    items: [
      'Immigration',
      'Threats to Democracy',
      'The Role of Government',
      'Government Efficiency',
      'Healthcare',
      'Political Violence and Polarization',
    ],
  },
  {
    group: '🏳️‍🌈 Social',
    items: [
      'Cancel Culture & Online Accountability',
      'Abortion',
      'Affirmative Action',
      'Addressing Racism',
      'Free Speech vs Hate Speech',
      'Diversity, Equity, and Inclusion',
    ],
  },
  {
    group: '🎨 Cultural',
    items: [
      'Holidays across Cultures',
      'Religious Identity',
      'Cultural Exchange',
      'Identity',
      'Life at School Lightning Round',
      'Pop Culture & Entertainment Lightning Round',
      'Purpose & Life Goals',
    ],
  },
  {
    group: '💵 Economic',
    items: [
      'Income Inequality',
      'Universal Basic Income',
      'Improving the Economy',
      'Economic Development',
      'Tariffs & Global Trade',
    ],
  },
  {
    group: '⚖️ Legal',
    items: [
      'Incarceration & Criminal Justice',
      'Policing',
      'Gun Control',
      'Drug Policy',
      'The Death Penalty',
      'Euthanasia & Assisted Dying',
    ],
  },
  {
    group: '🌎 Global',
    items: ['Climate Change', 'War & Foreign Intervention', 'Israel Palestine Conflict'],
  },
  {
    group: '🔮 Future',
    items: [
      'The Future of the Family',
      'The Future of Higher Education',
      'The Future of Gender Equality',
      'The Future of Work',
      'The Future of Capitalism',
      'The Future of the Media',
      'Imagining the Future',
    ],
  },
  {
    group: '📱Technology',
    items: [
      'Artificial Intelligence',
      'Social Media & Youth',
      'Tech Regulation',
      'Artificial Intelligence Lightning Round',
      'Science & Technology Lightning Round',
    ],
  },
  {
    group: '🏥 Health',
    items: ['Improving Physical Health', 'Mental Health'],
  },
  {
    group: '💭 Philosophy',
    items: [
      'Bioethics & Emerging Technologies',
      'Ethics & Daily Life Lightning Round',
      'Personality: Nature vs Nurture',
      'The Ethics of Eating Meat',
    ],
  },
  {
    group: '🤪 Miscellaneous',
    items: ['Lightning Round Topics', 'Free Will'],
  },
]

export const DISCUSSION_TOPIC_GROUP_OPTIONS: GroupBase[] = DISCUSSION_TOPICS.map(group => ({
  label: group.group,
  options: group.items.map(item => ({ label: item, value: item })),
}))
